import React from 'react';
import Loader from '@nib/loader';
import styled, { css } from 'styled-components';
export const CenterContainer = styled.div`
  text-align: center;
  line-height: 391px;
`;
export const BraintreeDropinContainer = styled.div`
  min-height: ${props => props.loading ? '391px;' : '200px;'};
  max-width: 700px;

  ${props => props.invalid && css`
      border: 2px solid #d21603;
    `}
`;
const BraintreeLoader = () => React.createElement(CenterContainer, null, React.createElement(Loader, {
  size: 'md'
}));
BraintreeLoader.defaultProps = {
  loading: false
};
export default BraintreeLoader;